/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_CompleteInputs */



/**
* | output |
* | --- |
* | "Loudness normalization complete" |
*
* @param {Audio_Description_Export_Loudness_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_complete = /** @type {((inputs?: Audio_Description_Export_Loudness_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Normalisation du loudness terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautheitsnormalisierung abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Normalizzazione del volume completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нормализация громкости завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Normalización de sonoridad completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("响度归一化完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音量の正規化が完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ध्वनि स्तर का सामान्यीकरण पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Normalização de intensidade sonora concluída")
	return /** @type {LocalizedString} */ ("Loudness normalization complete")
});